import React, {useEffect} from 'react';

import Body from "../common/Body";
import SlidePremiumSection from "./section/SlidePremiumSection";
import {HomeProvider} from "../../context/homeContext";
import RelatedSection from "./section/RelatedSection";
import CategorySection from "./section/CategorySection";
import {generateHeadTags} from "react-seo-tools";
import {Helmet} from "react-helmet";

const TITLE = 'Gái gọi - Gái gọi cao cấp - Checkerviet';
const DESCRIPTION = 'Gái gọi cao cấp Hà Nội, Sài Gòn trang web tìm gai goi cao cap tốt nhất tại Việt Nam. Chúng tôi chỉ có những cô gái THẬT tại Ha Noi, Sai Gon, Đà Nẵng, Hải Phòng...';

const MainContent = () => {
	return (
		<div>
			<Helmet>
				{generateHeadTags({
					title: TITLE,
					description: DESCRIPTION,
					openGraph: {
						type: 'website',
						title: TITLE,
					},
				})}
			</Helmet>

			<section className="mb-4">
				<SlidePremiumSection />
			</section>

			<section className="mb-4">
				<CategorySection />
			</section>

			<section className="mb-4">
				<RelatedSection />
			</section>
		</div>
	);
}

const Homepage = () => {
	useEffect(() => {
		document.title = TITLE;
		document.querySelector('meta[name="description"]').setAttribute("content", DESCRIPTION);
	}, []);

	return (
		<HomeProvider>
			<Body mainContent={<MainContent/>} sidebarContent={null} />
		</HomeProvider>
	);
};

export default Homepage;
